import { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";
import api, { API_URL } from "../services/api";

import "../styles/exams.css";

function Exams() {
  const [searchParams] = useSearchParams();

  const selectedCategory =
    searchParams.get("category") || "";

  const [exams, setExams] = useState([]);
  const [categories, setCategories] = useState([]);

  const [search, setSearch] = useState("");
  const [category, setCategory] =
    useState(selectedCategory);

  const [priceFilter, setPriceFilter] =
    useState("all");

  const [currentPage, setCurrentPage] =
    useState(1);

  const examsPerPage = 9;

  useEffect(() => {
    fetchExams();
    fetchCategories();
  }, []);

  useEffect(() => {
    setCategory(selectedCategory);
    setCurrentPage(1);
  }, [selectedCategory]);

  const fetchExams = async () => {
    try {
      const response = await api.get("/exams");

      setExams(response.data);

    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await api.get("/categories");

      setCategories(response.data);

    } catch (error) {
      console.error(error);
    }
  };

  const filteredExams = useMemo(() => {
    return exams.filter((exam) => {

      const matchesSearch =
        exam.title
          .toLowerCase()
          .includes(search.toLowerCase());

      const matchesCategory =
        category === "" ||
        exam.category === category;

      const matchesPrice =
        priceFilter === "all" ||
        (priceFilter === "free" &&
          exam.is_free) ||
        (priceFilter === "paid" &&
          !exam.is_free);

      return (
        matchesSearch &&
        matchesCategory &&
        matchesPrice
      );

    });
  }, [
    exams,
    search,
    category,
    priceFilter
  ]);

  const totalPages = Math.ceil(
    filteredExams.length /
      examsPerPage
  );

  const currentExams =
    filteredExams.slice(
      (currentPage - 1) *
        examsPerPage,
      currentPage *
        examsPerPage
    );

  return (
    <>
      <ClientNavbar />

      <div className="exams-page">

        <div className="page-header">

          <h1>
            {category
              ? `${category} Examination Papers`
              : "All Examination Papers"}
          </h1>

          <p>
            {category
              ? `Showing examination papers under ${category}.`
              : "Search and browse examination papers from different institutions."}
          </p>

        </div>

        <div className="filters">

          <input
            type="text"
            placeholder="Search exams..."
            value={search}
            onChange={(e) => {
              setSearch(
                e.target.value
              );
              setCurrentPage(1);
            }}
          />

          <select
            value={category}
            onChange={(e) => {
              setCategory(
                e.target.value
              );
              setCurrentPage(1);
            }}
          >

            <option value="">
              All Categories
            </option>

            {categories.map(
              (cat) => (

                <option
                  key={cat.id}
                  value={cat.name}
                >
                  {cat.name}
                </option>

              )
            )}

          </select>

          <select
            value={priceFilter}
            onChange={(e) => {
              setPriceFilter(
                e.target.value
              );
              setCurrentPage(1);
            }}
          >

            <option value="all">
              All
            </option>

            <option value="free">
              Free
            </option>

            <option value="paid">
              Paid
            </option>

          </select>

        </div>

        <div className="exam-grid">

          {currentExams.map(
            (exam) => (

              <div
                className="exam-card"
                key={exam.id}
              >

                <img
                  src={
                    exam.thumbnail_url
                      ? `${API_URL}${exam.thumbnail_url}`
                      : "https://via.placeholder.com/400x220?text=CompExams"
                  }
                  alt={exam.title}
                />

                <div className="exam-content">

                  <span className="category-badge">
                    {exam.category}
                  </span>

                  <h3>
                    {exam.title}
                  </h3>

                  <p>
                    {exam.description
                      ? exam.description.substring(
                          0,
                          90
                        )
                      : "No description available."}
                    ...
                  </p>

                  <div className="exam-bottom">

                    <span className="price">

                      {exam.is_free
                        ? "FREE"
                        : `KES ${exam.price}`}

                    </span>

                    <Link
                      to={`/exam/${exam.id}`}
                      className="view-btn"
                    >
                      View Details
                    </Link>

                  </div>

                </div>

              </div>

            )
          )}

        </div>

        <div className="pagination">

          <button
            disabled={
              currentPage === 1
            }
            onClick={() =>
              setCurrentPage(
                currentPage - 1
              )
            }
          >
            Previous
          </button>

          <span>
            Page {currentPage} of{" "}
            {totalPages || 1}
          </span>

          <button
            disabled={
              currentPage ===
                totalPages ||
              totalPages === 0
            }
            onClick={() =>
              setCurrentPage(
                currentPage + 1
              )
            }
          >
            Next
          </button>

        </div>

      </div>

      <Footer />

    </>
  );
}

export default Exams;